/*
src/ui-panels/LayoutPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {FormGroup, Checkbox, Slider} from '@blueprintjs/core';


export class LayoutPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {width: null, height: null, horizon: null, peak: null, margin: null};
		this._propertiesOfInterest = [];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSetParams = this.handleSetParams.bind(this);
		this.handleSetOptions = this.handleSetOptions.bind(this);
	
		this._paramsMan = this.props.workspace.getParamsManager();
		this._optionsMan = this.props.workspace.getOptionsManager();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);
		this._optionsMan.registerCallback('change', this.forceRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSetParams(p) {
		this._paramsMan.setParams(p);
	}

	handleSetOptions(o) {
		this._optionsMan.setOptions(o);
	}


	render() {

		let params = this._paramsMan.getParams(this._paramsOfInterest);
		let options = this._optionsMan.getOptions();
		
		return (
			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<Checkbox id="allow-fit-to-window-check" label="Fit Diagram to Window"
					checked={options.allowFitToWindow}
					onChange={e => this.handleSetOptions({allowFitToWindow: e.target.checked})}
					style={{margin: "0 0 20px 0"}} />

				<FormGroup label="Width" labelFor="width-slider">
					<Slider id="width-slider" min={options.minWidth} max={options.maxWidth} stepSize={1} labelStepSize={200}
						onChange={value => this.handleSetParams({width: value})} value={params.width}
						disabled={options.allowFitToWindow} />
				</FormGroup>

				<FormGroup label="Height" labelFor="height-slider">
					<Slider id="height-slider" min={options.minHeight} max={options.maxHeight} stepSize={1} labelStepSize={200}
						onChange={value => this.handleSetParams({height: value})} value={params.height}
						disabled={options.allowFitToWindow} />
				</FormGroup>

				<FormGroup label="Horizon" labelFor="horizon-slider">
					<Slider id="horizon-slider" min={0.0} max={0.4} stepSize={0.005} labelStepSize={0.1}
						onChange={value => this.handleSetParams({horizon: value})} value={params.horizon} />
				</FormGroup>

				<FormGroup label="Peak" labelFor="peak-slider">
					<Slider id="peak-slider" min={0.5} max={1.0} stepSize={0.005} labelStepSize={0.1}
						onChange={value => this.handleSetParams({peak: value})} value={params.peak} />
				</FormGroup>

				<FormGroup label="Margin" labelFor="margin-slider">
					<Slider id="margin-slider" min={0.0} max={0.3} stepSize={0.005} labelStepSize={0.1}
						onChange={value => this.handleSetParams({margin: value})} value={params.margin} />
				</FormGroup>
			</div>
		);
	}

}


